import React, { useCallback, useMemo } from "react";
import { Checkbox } from "@alm/flow-ds/components";
import { ElementComponentProps } from "elements/types";
import { createGetElementData } from "../../data/form/elementSelectors";
import { State } from "data";
import { useSelector } from "react-redux";
import { CheckboxElement } from "records/Element";
import { useStandardElement } from "components/Forms/Element";
import DisplayOnlyValue from "elements/DisplayOnlyValue";

function CheckboxReactive({
	fid,
	vid,
	id,
	index,
	rowIndex,
	uuid,
	hint,
	label,
	required,
	disabled,
	displayOnly,
}: ElementComponentProps<CheckboxElement>) {
	const getData = useMemo(createGetElementData, []);
	const selectorProps = useMemo(
		() => ({ fid, vid, id, index, rowIndex, uuid }),
		[fid, vid, id, index, rowIndex, uuid]
	);
	const data = useSelector((state: State) => getData(state, selectorProps));
	const { eid, setDataAndQueue } = useStandardElement({
		fid,
		vid,
		id,
		index,
		rowIndex,
		uuid,
	});

	// Memoize some values
	const value = useMemo(() => data.value, [data]) as string;
	const isChecked = useMemo(
		() => (data && data.value ? true : false),
		[data]
	);

	// onChange callback handler
	const onChange = useCallback(() => {
		setDataAndQueue(data, { id, value: !isChecked });
	}, [setDataAndQueue, data, id, isChecked]);

	// Display only
	if (displayOnly) {
		return <DisplayOnlyValue label={label} value={isChecked.toString()} />;
	}

	return (
		<Checkbox
			id={eid}
			value={value}
			checked={isChecked}
			onChange={onChange}
			hint={hint}
			feedback={data.feedback}
			required={required}
			label={label}
			disabled={disabled}
			status={data.status}
		/>
	);
}

export default React.memo(CheckboxReactive);
